// extracted by mini-css-extract-plugin
export var editInput = "_g7-0";
export var editInputCompact = "_g7-2";
export var editInputLarge = "_g7-1";
export var editInputSmall = "_g7-3";